// Load Groups translations for React Admin resource
export const loadGroupsResource = {
  name: 'Load Groups',
  fields: {
    id: 'ID',
    name: 'Name',
    site: 'Site',
    siteId: 'Site',
    siteName: 'Site Name',
    description: 'Description',
    location: 'Location',
    maxPower: 'Max Power (kW)',
    currentPower: 'Current Power (kW)',
    powerUsage: 'Power Usage',
    voltage: 'Voltage',
    maxCurrent: 'Max Current (A)',
    phase: 'Phase',
    priorityLevel: 'Priority Level',
    loadBalancingEnabled: 'Load Balancing Enabled',
    loadBalancing: 'Load Balancing',
    status: 'Status',
    lastStatusUpdate: 'Last Status Update',
    chargers: 'Chargers',
    utilized: 'Utilized',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    ocppServerId: 'OCPP Server',
    lmsTemplateId: 'LMS Template',
  },
};

// Custom load groups translations for components
export const loadGroups = {
  priority: 'Priority',
  noChargers: 'No chargers assigned to this load group',
  statuses: {
    active: 'Active',
    inactive: 'Inactive',
    maintenance: 'Maintenance',
  },
  phases: {
    single: 'Single Phase',
    three: 'Three Phase',
  },
  sections: {
    basic: 'Basic Information',
    electrical: 'Electrical Configuration',
    powerManagement: 'Power Management',
    settings: 'Settings',
    statistics: 'Statistics Overview',
    info: 'Load Group Information',
    chargers: 'Assigned Chargers',
  },
  tabs: {
    details: 'Details',
    chargers: 'Chargers',
  },
  stats: {
    chargers: 'Chargers',
    activeChargers: 'Active Chargers',
    powerUtilization: 'Power Utilization',
    capacity: 'Capacity Allocation',
    allocated: 'allocated',
  },
  list: {
    title: 'Load Groups',
    filters: {
      search: 'Search by name',
    },
  },
  create: {
    title: 'Create Load Group',
    subtitle: 'Configure a new load group for power management',
    backToList: 'Back to load groups',
  },
  edit: {
    title: 'Edit Load Group',
    subtitle: 'Manage load group configuration and power allocation',
    backToList: 'Back to load groups',
  },
  delete: {
    sectionTitle: 'Danger Zone',
    title: 'Delete Load Group',
    content: 'Are you sure you want to delete this load group? This action cannot be undone.',
    hasChargersContent: 'This load group cannot be deleted because it has chargers attached. Please reassign or remove all chargers before deletion.',
    warning: 'Warning: This action is permanent!',
    message: 'You are about to delete the load group',
    prompt: 'To confirm deletion, type',
    promptBelow: 'in the field below:',
    typePlaceholder: 'Type "%{name}" to confirm',
    nameDoesNotMatch: 'Name does not match',
    button: 'Delete Load Group',
  },
  actions: {
    create: 'Create Load Group',
    save: 'Save Changes',
    delete: 'Delete Load Group',
  },
  helpers: {
    name: 'Unique name within the site',
    site: 'Site where this load group is located',
    siteCannotChange: 'Site cannot be changed after creation',
    description: 'Optional description of this load group',
    location: 'Specific location within the site (e.g., "Level 2 Parking")',
    phase: 'Electrical phase configuration',
    voltage: 'Operating voltage in volts',
    maxCurrent: 'Maximum current capacity in amperes',
    maxPower: 'Maximum power this group can provide',
    priorityLevel: '1 (highest) to 10 (lowest) - used for load shedding',
    status: 'Current operational status',
    ocppServer: 'OCPP server managing this group',
    lmsTemplate: 'Load management system template (optional)',
  },
  validation: {
    nameTooLong: 'Name is too long',
    descriptionTooLong: 'Description is too long',
    locationTooLong: 'Location is too long',
    voltageTooLow: 'Voltage is too low',
    voltageTooHigh: 'Voltage is too high',
    currentNegative: 'Current must be positive',
    currentTooHigh: 'Current is too high',
    powerNegative: 'Power must be positive',
    powerTooLow: 'Power must be at least 1 kW',
    powerTooHigh: 'Power is too high',
    powerBelowChargers: 'Cannot reduce max power below %{minPower}kW (total charger capacity)',
    priorityTooLow: 'Priority must be at least 1',
    priorityTooHigh: 'Priority cannot exceed 10',
    singlePhaseVoltage: 'Single phase voltage cannot exceed 480V',
  },
  warnings: {
    electricalChanges: 'Changes to electrical configuration may affect connected chargers',
    singlePhaseVoltage: 'Single phase configurations are limited to 480V',
    highUtilization: 'This load group is operating near capacity. Consider redistributing chargers or increasing capacity.',
  },
  info: {
    priorityNote: 'Lower numbers have higher priority. During load shedding, lower priority groups are reduced first.',
    calculatedPower: 'Calculated power capacity: %{power} kW',
  },
  notifications: {
    created: 'Load group created successfully',
    updated: 'Load group updated successfully',
    deleted: 'Load group deleted successfully',
    deleteError: 'Failed to delete load group',
  },
};